import type {dayjs} from '@myparcel-frontend/utils';

export const formatDateToUTC = (date: dayjs.Dayjs, format: string) => date.utc().format(format);
